import { BaseModel } from '../../_base/crud';
import { Blocker, Resource } from '../../models';
import { Form } from '../../../views/pages/forms-templates/models';

export class Template extends BaseModel {
  id: number;
  name: string;
  category_id: any;
  template: any;
  all_roles: boolean;
  allow_payment: boolean;
  is_backstage: boolean;
  is_service: boolean;
  is_private_service_allowed: boolean;
  exclude_from_filtered_view: any;
  url_resource;
  compliance: {
    ids: number[];
    is_edited: boolean;
  };
  program_id: number;
  resources: Partial<Resource>[];
  blockers: Partial<Blocker>[];
  form: Form;
  is_locked: boolean;
  default_view: string;
  title: any;
  description: any;
  priority: any;
  task_responsible_users: any;
  task_followers: any;
  behavior: any;
  is_active: boolean;
  objective: string;
  critical_data: string;
  data_sources: string;
  authorized_communication_methods: string[];
}
